import { z } from 'zod'

// The agent cites a public web page by the exact URL it searched or scraped plus a verbatim anchor. The
// resolver hydrates title/quote from the per-decision web-page cache (search results + scraped pages).
export const UrlCitationAgentInputSchema = z.object({
  type: z.literal('url'),
  url: z.string().describe('Exact URL from a web_search result or a scrape_url call you made'),
  anchor: z.string().trim().min(1).describe('Verbatim phrase copied from the page content supporting the claim'),
})

// `verification` records how far the citation was checked: `scraped_content` means the anchor was verified
// against the page markdown the agent read, so a `quote` is present; `search_result` means the URL appeared
// in a web-search result but was never scraped, so there is no verifiable quote (only the link is shown).
export const UrlCitationResolvedSchema = z.object({
  sourceType: z.literal('url'),
  sourceLabel: z.string(),
  url: z.string(),
  title: z.string().optional(),
  quote: z.string().optional(),
  anchor: z.string(),
  verification: z.enum(['scraped_content', 'search_result']),
})
export type UrlCitationResolved = z.infer<typeof UrlCitationResolvedSchema>
